import { Component, effect, signal } from '@angular/core';
import {MatExpansionModule} from '@angular/material/expansion';
import { Ballot } from 'src/app/ballot/backend-types';
import { BallotListService } from 'src/app/ballot-list/ballot-list.service';
import { Router } from '@angular/router';
import {MatIconModule} from '@angular/material/icon';
import { ballotRoute } from '../../route-names';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { PollsItemComponent } from './polls-item/polls-item.component';
import { MatBadgeModule } from '@angular/material/badge';
import { ApiAboutService } from 'src/app/Services/api-about.service';
import { EventResultsService } from 'src/app/Services/event-results.service';
import { ElectorDataService } from 'src/app/Services/elector-data.service';
import { DialogService, DialogType } from 'src/app/Services/dialog.service';

@Component({
    selector: 'app-polls-panel',
    imports: [MatExpansionModule, MatIconModule, PollsItemComponent, MatBadgeModule],
    providers: [],
    templateUrl: './polls-panel.component.html',
    styleUrl: './polls-panel.component.scss'
})
export class PollsPanelComponent {
  events: Ballot[] = [];
  eventsCount: number = 0;
  eventsOpenState = signal(false);
  totalEvents = signal<number>(0);
  dialogTitle?: string;
  dialogText?: string;
  public displaySpinner: boolean = false;
  
  constructor(
    private aboutService: ApiAboutService,
    private readonly listService: BallotListService,
    private readonly router: Router,
    private readonly resultsService: EventResultsService,
    private readonly userService: ElectorDataService,
    private dialogService: DialogService,
    private announcer: LiveAnnouncer
  ) {
    effect(() => {
      this.events = listService.getBallots().filter((event) => event.eventType?.toLowerCase().includes("poll")) ?? [];
      this.eventsCount = this.events.length;
    })
  }

  selectedPoll(selectedEventId: number): void {
    let pollIndex = this.events.findIndex((ballot) => (ballot.eventId === selectedEventId));
    if(pollIndex < 0){
      console.error("Missing poll!");
      return;
    }
    this.aboutService.headerImageUrl.set(this.userService.getImageUrlForEventOrOrg(selectedEventId));
    this.aboutService.headerTitle.set(this.events[pollIndex].voteEventData.description);
    this.aboutService.headerDates.set(this.listService.formatDateRange(this.events[pollIndex]));
    this.aboutService.setElectionStartAndClose(this.events[pollIndex].eventActivation, this.events[pollIndex].eventExpiration);
    this.listService.setBallotService(this.listService.getOverallIndexForEventID(selectedEventId));
    this.router.navigate(ballotRoute);
  }

  async selectedPollResults(selectedEventId: number){
    let pollIndex = this.events.findIndex((ballot) => (ballot.eventId === selectedEventId));
      if(pollIndex < 0){
        console.error("Missing poll!");
        return;
      }
    if(this.listService.canViewPollResults(this.events[pollIndex])) {
      try {
        await this.resultsService.getResults(this.events[pollIndex]);
      } catch(err) {
        this.dialogTitle = $localize`Cannot View Results`;
        this.dialogText = $localize`We could not process your request. Please try again or use the "Contact Support" link for assistance.`;
        this.dialogService.openDialog(DialogType.ERROR, this.dialogTitle, this.dialogText);
      }
    } else {
      this.dialogTitle = $localize`Cannot View Results`;
      if(this.events[pollIndex].voteEventData.showResults) {
        this.dialogText = $localize`You must first submit your response to a poll in order to view the results.`;
      } else {
        this.dialogText = $localize`Results for this poll cannot be viewed.`;
      }
      this.dialogService.openDialog(DialogType.ALERT, this.dialogTitle, this.dialogText);
    }
  }

  onPanelOpen(): void {
    this.eventsOpenState.set(true);
    this.announcer.announce('You have '+ this.eventsCount + ' polls available.', "assertive")
  }

  onPanelClose(): void {
    this.eventsOpenState.set(false);
    this.announcer.announce('Click to view your available polls.' , "assertive")
  }
  get openDescriptionBallot(): string {
    return $localize`Select a poll to begin making selections.`;
  }

  get closeDescriptionBallot(): string {
    return $localize`Click here to view your available polls.`;
  }

  get EventsOpenStateDescription(): string {
    return $localize`Click to view your available polls.`;
  }

  numBallots(): number {
    return this.events.filter(b => this.listService.isActionable(b)).length;
  }

  areNoBallots(): boolean {
    return this.numBallots() == 0;
  }
}
